import React from 'react';
import {useSelector} from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';

import Utility from '../../../util/utilityfunctions';

import OutputText from '@ey/canvascoreservices/OutputText';

import StyledLabelAndDate from './StyledLabelAndDate';

const LabelAndDate = ({
	label = null,
	author = null,
	date = null,
	withHours = true,
	body1,
	body2,
	light,
	color = null,
	...rest
}) => {
	const [userDateFormat, userTimezone] = useSelector(({userPreferences}) => [
		userPreferences.dateFormat,
		userPreferences.timeZoneISOCode
	]);
	const timeFormat = 'HH:mm';
	const timePlaceholder = '00:00';

	const getDatetimeFromTimezone = (datetime, type = 'hour') => {
		const timeZoneNumber = Utility.getTimezone(userTimezone);
		let result = moment.utc(datetime);
		if (timeZoneNumber >= 0) {
			result = result.add(timeZoneNumber, type);
		} else {
			result = result.subtract(Math.abs(timeZoneNumber), type);
		}
		return result;
	};

	const convertedDate = getDatetimeFromTimezone(date);
	const displayDate = date ? convertedDate.format(userDateFormat) : userDateFormat;
	const displayHours = date ? convertedDate.format(timeFormat) : timePlaceholder;

	const sharedProps = {body1, body2, light};

	const renderLabel = () => {
		const props = {
			...sharedProps,
			children: `${label}:`
		};
		return <OutputText {...props} />;
	};

	const renderAuthor = () => {
		const props = {
			...sharedProps,
			regular: true,
			light: false,
			children: `${author}`
		};
		return <OutputText {...props} />;
	};

	const renderTime = (content) => {
		const props = {
			...sharedProps,
			regular: true,
			light: false,
			children: content
		};
		return <OutputText {...props} />;
	};

	let title = `${displayDate}`;
	if (label) title = `${label}: ${title}`;
	if (withHours) title = `${title} | ${displayHours}`;

	const wrapperProps = {
		title,
		...rest
	};

	if (color) wrapperProps.$color = color;

	return (
		<StyledLabelAndDate {...wrapperProps}>
			{label && renderLabel()}
			{author && renderAuthor()}
			{renderTime(displayDate)}
			{withHours && renderTime('|')}
			{withHours && renderTime(displayHours)}
		</StyledLabelAndDate>
	);
};

LabelAndDate.propTypes = {
	label: PropTypes.string,
	author: PropTypes.string,
	date: PropTypes.string, //example: 2023-05-30T16:47:31.5514313+00:00
	withHours: PropTypes.bool,
	body1: PropTypes.bool,
	body2: PropTypes.bool,
	light: PropTypes.bool,
	color: PropTypes.string
};

export default LabelAndDate;
